import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Divider, Drawer, IconButton, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

import { SidebarContext } from 'src/context/SidebarContext';
import { MenuItems } from 'src/components/MenuItems';
import menuItems from './menuItems';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const LogoStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

const DRAWER_WIDTH = 240;

const Sidebar = (): JSX.Element => {
  const navigate = useNavigate();
  const sidebarCtx = useContext(SidebarContext);
  const theme = useTheme();

  const menuClickHandler = (link: string) => {
    navigate(link);
    sidebarCtx.toggleSidebar();
  };

  return (
    <>
      <Drawer
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          '& .MUIDrawer-paper': {
            width: DRAWER_WIDTH,
            boxSizing: 'border-box',
          },
        }}
        variant='temporary'
        anchor='left'
        open={sidebarCtx.sidebarToggle}
        onClose={sidebarCtx.toggleSidebar}
      >
        <DrawerHeader>
          <LogoStyled>
            <Typography variant='subtitle2' component='div' align='left'>
              Khello Logo
            </Typography>
          </LogoStyled>
          <IconButton onClick={sidebarCtx.toggleSidebar}>
            {theme.direction === 'ltr' ? <ChevronLeft /> : <ChevronRight />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <MenuItems links={menuItems} menuClickHandler={menuClickHandler} />
      </Drawer>
    </>
  );
};

export default Sidebar;
